import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// Redux.
import { connect } from 'react-redux';

// Firebase.
import { getAnalytics, logEvent } from "firebase/analytics";

// Components.
import { loadTrack } from '../components/audioHelper';
import AudioPlayerDrawer from '../components/AudioPlayerDrawer';
import SavedLibrary from '../components/SavedLibrary';
import SigninRequired from '../components/SigninRequired';



const Saved = ({
    authenticated,
}) => {

    const [showAudioPlayerDrawer, setShowAudioPlayerDrawer] = useState(false);
    const navigate = useNavigate();
    const trackInfoRef = useRef(null)

    useEffect(() => {
        const analytics = getAnalytics();
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'saved'
        });
    }, []);

    const playTrack = (trackInfo, startSeconds) => () => {
        trackInfoRef.current = trackInfo;
        loadTrack(trackInfo.mp3URL, startSeconds);
        setShowAudioPlayerDrawer(true);
    };
    const closeAudioPlayer = () => {
        setShowAudioPlayerDrawer(false);
    }

    if (authenticated !== true) {
        return <SigninRequired authenticated={authenticated} />;
    }
    return (
        <div className='container appScreen savedPage'>
            <AudioPlayerDrawer
                open={showAudioPlayerDrawer}
                onClose={closeAudioPlayer}
                source={trackInfoRef.current ? trackInfoRef.current.source : null}
                trackId={trackInfoRef.current ? trackInfoRef.current.id : null} />
            <SavedLibrary
                playTrack={playTrack}
                onBack={() => navigate('/library')}
            />
        </div>
    );
}

Saved.propTypes = {
    authenticated: PropTypes.bool
}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(Saved);
